import { useParams } from 'react-router-dom';
import { fetchClient } from '@/api/clients';
import { useAuthGate } from '@/hooks/useAuthGate';
import { AuthGate } from '@/components/AuthGate';
import { ClientDetailView } from './ClientDetailView';

export function ClientDetailPage() {
  const { id } = useParams<{ id: string }>();
  const fetcher = () => fetchClient(id ?? '');
  const state = useAuthGate(fetcher, [id]);

  // key={data.id} — форсирует свежий mount ClientDetailView (и сброс его
  // локального состояния данных/редактирования) при переходе между разными
  // клиентами без полной перезагрузки страницы (сам ClientDetailPage не
  // размонтируется, меняется только :id в роуте).
  return <AuthGate state={state}>{(data) => <ClientDetailView key={data.id} data={data} />}</AuthGate>;
}
